var render = function (_h,_vm) {var _c=_vm._c;return _c('a-row',{attrs:{"gutter":24}},_vm._l((_vm.props.properties),function(formItem){return _c(_vm.props.comFn(formItem),{key:formItem.key,tag:"component",attrs:{"formitem":formItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }